import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';

export function DefaultText(
    {
        txtLabel        = "",
        txtErrorLabel   = "",
        txtErrorToggle  = false,
        changeTask      = () => {},
        keyDownTask     = () => {},
        inputID         = "",
        inputDisabled   = false,
        inputMaxLen     = 20,
        inputValue      = "",
        children,
        ...props
    })
{
    return (
        <div className='defaultTxtContainer2'>
            <div className='defaultTxtLblContainer'>
                <div className='defaultTxtLbl'>{txtLabel}</div>
                {
                    !txtErrorToggle ? "" :
                    <div className='defaultTxtErrorLbl'>
                        {
                            txtErrorLabel === "" ? 
                            "(Cannot be empty)" :
                            txtErrorLabel
                        }
                    </div>
                }
            </div>
            <input className='defaultTxtInput' id={inputID}
                onChange={changeTask}
                onKeyDown={keyDownTask}
                maxLength={inputMaxLen}
                value={inputValue}
                disabled={inputDisabled}
            />
        </div>
    )
}

export function PasswordText(
    {
        txtLabel        = "",
        txtErrorLabel   = "",
        txtErrorToggle  = false,
        changeTask      = () => {},
        keyDownTask     = () => {},
        inputID         = "",
        inputDisabled   = false,
        inputValue      = "",
        showPwd         = false,
        showPwdEvent    = () => {},
        children,
        ...props
    })
{
    return (
        <div className='defaultTxtContainer2'>
            <div className='defaultTxtLblContainer'>
                <div className='defaultTxtLbl'>{txtLabel}</div>
                {
                    !txtErrorToggle ? "" :
                    <div className='defaultTxtErrorLbl'>
                        {
                            txtErrorLabel === "" ?
                            "(Cannot be empty)" :
                            txtErrorLabel
                        }
                    </div>
                }
            </div>
            <div className='passwordContainer'>
                <input type={showPwd ? "text" : "password"} className='defaultTxtInput' id={inputID} 
                    onChange={changeTask}
                    onKeyDown={keyDownTask}
                    value={inputValue}
                    disabled={inputDisabled}
                />
                <div className="shpassword" onClick={showPwdEvent}>
                    {showPwd ? <AiOutlineEye/> : <AiOutlineEyeInvisible/>}
                </div>
            </div>
        </div>
    )
}